import {
    HttpResponse,
    ServiceQueueItemModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class ServiceQueueItemsDataService implements CrudService<ServiceQueueItemModel, ServiceQueueItemModel> {
    getAll(query: CrudDataQuery<ServiceQueueItemModel>): Promise<CrudEnumerableResponse<ServiceQueueItemModel>> {
        return ApiService.api.getServiceQueueItemBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<ServiceQueueItemModel>): Promise<CrudEnumerableResponse<ServiceQueueItemModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ServiceQueueItemModel>> {
        return ApiService.api.getServiceQueueItemById(id, params);
    }

    create(item: ServiceQueueItemModel, params?: RequestParams): Promise<CrudResponse<ServiceQueueItemModel>> {
        return ApiService.api.insertServiceQueueItem(item, params);
    }

    update(item: ServiceQueueItemModel, params?: RequestParams): Promise<ServiceQueueItemModel> {
        throw new Error('NotImplemented');
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ServiceQueueItemModel> {
        throw new Error('NotImplemented');
    }

    delete(query: CrudDataQuery<ServiceQueueItemModel>): Promise<CrudEnumerableResponse<ServiceQueueItemModel>> {
        throw new Error('NotImplemented');
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationServiceQueueItem(query, params).then((req: any) => req.data.returnValue);
    }
    
    download(query: CrudDataQuery<ServiceQueueItemModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: ServiceQueueItemModel, params?: RequestParams): Promise<CrudResponse<ServiceQueueItemModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getServiceQueueItemGroupped(query, params);
    }

}
